'use client';

var DEFAULT_OPTION = {
    max: 99,
    min: 0,
    canBeEmpty: false,
    fontSizeErrorText: 12
};

export { DEFAULT_OPTION };
//# sourceMappingURL=constants.js.map
